/** @format */

exports.EMAILJS_SERVICE_ID = "service_ttu3zpo";
exports.EMAILJS_PUBLIC_KEY = "g9gaXThGXNdtwYKPU";
exports.EMAILJS_CONTACT_TEMPLATE_ID = "template_e9ody6b";
exports.EMAILJS_CAREERS_TEMPLATE_ID = "template_d0al9bc";
